const Offerings = ({ isFullList = true }) => {
  return (
    <div className="offerings-section">
      <h2>Our Offerings</h2>
      <p>
        Explore our diverse offerings designed to guide you on your journey of
        well-being.
      </p>

      <div className="cards-container">
        <div className="card">
          <h3>Breathwork</h3>
          <p>
            Experience deep breathwork techniques that enhance mental clarity,
            reduce stress, and improve overall vitality.
          </p>
        </div>
        <div className="card">
          <h3>Healing / Restorative</h3>
          <p>
            Restorative practices to heal the body and mind, reduce stress, and
            promote inner peace.
          </p>
        </div>
        <div className="card">
          <h3>Mental Relaxation</h3>
          <p>
            Techniques to calm the mind, relieve mental stress, and enhance
            clarity and focus.
          </p>
        </div>
        <div className="card">
          <h3>Sun Salutations Special</h3>
          <p>A flowing series of 12 poses that warm up the body, stretch the muscles, and connect breath with movement. It’s a powerful sequence, perfect for starting your yoga practice or as a full-body workout.</p>
        </div>
        {isFullList && (
          <>
            <div className="card">
              <h3>Yoga Nidra</h3>
              <p>
                A deeply restful practice that promotes relaxation and healing
                through guided meditation, helping you achieve a state of
                conscious relaxation.
              </p>
            </div>
            <div className="card">
              <h3>Subtle Rejuvenating Movements</h3>
              <p>
                Gentle, restorative movements targeting the face, joints, and
                major muscles to improve flexibility, release tension, and
                energize the body.
              </p>
            </div>
            <div className="card">
            <h3>Physical Exercise</h3>
            <p>
              Movement practices to improve strength, flexibility, and overall
              physical health.
            </p>
          </div>
          </>
        )}
      </div>
    </div>
  );
};

export default Offerings;
